var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","padding":"20px","font-size":"2rem"}},[_c('h4',[_vm._v(_vm._s(_vm.formLabelAlign.title))]),_c('h1',[_vm._v("￥"+_vm._s(_vm.formLabelAlign.amt))]),_c('el-button',{staticStyle:{"width":"100%"},attrs:{"type":"success"},on:{"click":_vm.topay}},[_vm._v("立即支付")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }